import {questionFiled} from "./edit/EditScreenMoreMenu";
import * as RepOutputFormat from "../constants/RepOutputFormat";
import {of} from "../widgets/ActionPlaceholder";
import {ajaxJSON} from "../common/NamaCommon";
import {ActionHandler} from "../widgets/ActionHandler";
import * as NamaURLS from "../constants/NamaURLS";
import {isBarcodeOn} from "../login/ClientCache";
import * as DomainBaseEntities from "../constants/DomainBaseEntities";
import {ActionPerformer} from "../widgets/ActionPerformer";
import {currentUserId} from "../login/LoginPresenter";
import * as FieldType from "../constants/FieldType";
import {QuestionFieldsEditor} from "../widgets/QuestionFieldsEditor";
import {NamaKendoWindow, NamaWindowBtnData} from "./NamaKendoWindow";

export class EmailSenderView {
    constructor(presenter) {
        let that = this;
        that.extraFields = [];
        let questionFieldsEditor = new QuestionFieldsEditor(DomainBaseEntities.ReportDefinition);
        that.presenter = presenter;
        questionFieldsEditor.metaData = presenter.metaData;
        that.questionsEditor = questionFieldsEditor;
        that.actionHandler = new ActionHandler();
        that.actionHandler.actionInfo = of("emailSend");
        that.actionHandler.performer = new ActionPerformer();
        that.actionHandler.performer.performAction = () => {
            let fields = that.allQuestions();
            let req = {};
            for (let field of fields) {
                req[field.id] = field.value;
            }
            req["barCodeOn"] = isBarcodeOn();
            req["userId"] = currentUserId();
            return ajaxJSON(NamaURLS.SendEmailWithResult, {
                request: JSON.stringify(req),
            });
        };
        that.actionHandler.questionFieldsEditor = questionFieldsEditor;
        let questionFields = [];
        questionFields.push(questionFiled("toEmp1", DomainBaseEntities.Employee));
        questionFields.push(questionFiled("toEmp2", DomainBaseEntities.Employee));
        questionFields.push(questionFiled("toEmp3", DomainBaseEntities.Employee));
        questionFields.push(questionFiled("ccEmp1", DomainBaseEntities.Employee));
        questionFields.push(questionFiled("ccEmp2", DomainBaseEntities.Employee));
        questionFields.push(questionFiled("ccEmp3", DomainBaseEntities.Employee));
        questionFields.push(questionFiled("toEmail1", null, FieldType.Text));
        questionFields.push(questionFiled("toEmail2", null, FieldType.Text));
        questionFields.push(questionFiled("toEmail3", null, FieldType.Text));
        questionFields.push(questionFiled("cc1", null, FieldType.Text));
        questionFields.push(questionFiled("cc2", null, FieldType.Text));
        questionFields.push(questionFiled("cc3", null, FieldType.Text));
        let allowedFormats = [RepOutputFormat.PDF, RepOutputFormat.PPTX, RepOutputFormat.ODT, RepOutputFormat.XLS, RepOutputFormat.XLSX, RepOutputFormat.RTF, RepOutputFormat.DOCX, RepOutputFormat.HTML, RepOutputFormat.ODS, RepOutputFormat.TXT];
        questionFields.push(questionFiled("outputFormat", null, FieldType.Enum, allowedFormats));
        questionFields.push(questionFiled("subject", null, FieldType.Text));
        questionFields.push(questionFiled("content", null, FieldType.BigText));
        that.questionFields = questionFields;
    }

    addToExtraFields(fields) {
        this.extraFields.push(...fields);
    }

    allQuestions() {
        let that = this;
        let fields = that.questionsEditor.getQuestionFields();
        if (that.extraFields.length)
            fields.push(...that.extraFields);
        return fields;
    }

    show() {
        let that = this;
        let window = new NamaKendoWindow("emailSend", new NamaWindowBtnData("ok", () => {
            that.actionHandler.performer.performAction(that.actionHandler.actionInfo.getId(), that.questionsEditor.getQuestionFields(), that.presenter.metadata, that.presenter);
            window.closeWindow();
        }), new NamaWindowBtnData("cancel"));
        that.questionsEditor.edit(that.questionFields, [{id: "outputFormat", value: RepOutputFormat.PDF}], null, null, that.presenter, window, window);
        window.showWindow();
    }
}